<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <div class="display-1 mb-4 text-center">Divorce Answered Tools</div>
        <div class="subheading mb-4 text-center">Be resource rich with Divorce Answered’s unique products that are individualised, time efficient and save you money.</div>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <div class="headline mb-4 text-center">Login to continue</div>
        <v-card>
          <v-card-text>
            <v-card class="mb-4" v-if="error">
              <v-card-text>
                <p class="mb-0 red--text"><b>{{error.title}}:</b> {{error.message}}</p>
              </v-card-text>
            </v-card>
            <v-form id="login-form" ref="form" v-model="valid" lazy-validation @submit.prevent="onSubmit">
              <v-text-field
                v-model="email"
                :rules="emailRules"
                label="Email"
                prepend-icon="person"
              ></v-text-field>
              <v-text-field
                v-model="password"
                :rules="passwordRules"
                label="Password"
                prepend-icon="lock"
                type="password"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn text color="primary" to="forgot-password">Forgot password?</v-btn>
            <v-spacer></v-spacer>
            <v-btn type="submit" :disabled="loading" :loading="loading" color="primary" form="login-form">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="6">
        <div class="text-center mt-3">By signing in, you agree to our <a href="https://divorceanswered.com.au/terms-of-use/" target="_blank">Terms of Use</a> and <a href="https://divorceanswered.com.au/privacypolicy/" target="_blank">Privacy Policy</a> and <a href="https://divorceanswered.com.au/disclaimer/" target="_blank">Disclaimer.</a></div>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="6">
        <hr class="mt-4">
        <div class="subheading mt-4 text-center">Don't have an account? <v-btn outlined :to="'/register'">Register</v-btn></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    valid: true,
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+/.test(v) || 'E-mail must be valid'
    ],
    password: '',
    passwordRules: [
      v => !!v || 'Password is required'
    ]
  }),
  created () {
    this.$store.dispatch('clearError')
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    onSubmit () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('signin', { email: this.email, password: this.password })
      }
    }
  }
}
</script>
